"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealerSearchServiceV1Proxy = void 0;
class DealerSearchServiceV1Proxy {
    constructor(consumerID, delegate) {
        this.consumerID = consumerID;
        this.delegate = delegate;
    }
    getSelectedDealer() {
        var _a;
        return (_a = this.delegate.getSelectedDealer(this.consumerID)) !== null && _a !== void 0 ? _a : null;
    }
    setSelectedDealer(data) {
        this.delegate.setSelectedDealer(this.consumerID, data);
    }
    registerOnSelectedDealerChange(callback) {
        return this.delegate.registerOnSelectedDealerChange(this.consumerID, callback);
    }
}
exports.DealerSearchServiceV1Proxy = DealerSearchServiceV1Proxy;
//# sourceMappingURL=index.js.map